import {
  OPEN_SNACKBAR,
  CLOSE_SNACKBAR
} from '../constants/action-types';

export const openSnackbar = message => dispatch => dispatch({ message, type: OPEN_SNACKBAR });

export const closeSnackbar = () => dispatch => dispatch({ type: CLOSE_SNACKBAR });
